import { StoreState } from "..";

export const getUserInfo = (state: StoreState) => state.user.userInfo;
export const getUserEmail = (state: StoreState) => state.user.userInfo?.email;
export const getGeniusLevel = (state: StoreState) => state.user.userInfo?.geniusLevel;
